import { c as _c } from "react/compiler-runtime";
import { getNumericPostalCodeMask, isZip } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import type { FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormInput, { type FormInputProps } from './form-input';
export type FormZipProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  country?: Iso3166TwoDigitCountryCode;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
} & Omit<FormInputProps<TFieldValues>, 'name' | 'rules' | 'type' | 'autoComplete'>;
export default function FormZip(t0) {
  const $ = _c(17);
  let country;
  let props;
  let rules;
  if ($[0] !== t0) {
    ({
      rules,
      country,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = country;
    $[2] = props;
    $[3] = rules;
  } else {
    country = $[1];
    props = $[2];
    rules = $[3];
  }
  const {
    t
  } = useTranslation("ui");
  let t1;
  if ($[4] !== country) {
    t1 = getNumericPostalCodeMask(country);
    $[4] = country;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const mask = t1;
  const isNumeric = Boolean(mask);
  let t2;
  if ($[6] !== country || $[7] !== t) {
    t2 = value => {
      if (!value) {
        return true;
      }
      if (!isZip(value, country)) {
        return t("components.form.zip.errors.us-invalid");
      }
      return true;
    };
    $[6] = country;
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== rules || $[10] !== t2) {
    t3 = {
      validate: t2,
      ...rules
    };
    $[9] = rules;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const zipRules = t3;
  const t4 = isNumeric ? "numeric" : undefined;
  let t5;
  if ($[12] !== mask || $[13] !== props || $[14] !== t4 || $[15] !== zipRules) {
    t5 = <FormInput {...props} rules={zipRules} mask={mask} autoComplete="postal-code" inputMode={t4} />;
    $[12] = mask;
    $[13] = props;
    $[14] = t4;
    $[15] = zipRules;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}